/**
 * Messages para es-AR (Argentina, voseo rioplatense).
 * Strings adaptadas al registro argentino: "vos", imperativos con tilde,
 * "acá", terminología local donde aplica.
 */
import type { messages as base } from "./es-CL";

export const messages: Record<keyof typeof base, string> = {
  "login.eyebrow": "§ 01 · Simulador clínico longitudinal",
  "login.eyebrow.suffix": "Simulador clínico longitudinal",
  "login.hero.prefix": "Simu",
  "login.hero.suffix": "med",
  "login.tagline":
    "Un hospital virtual donde la IA razona en voz alta. Pacientes que evolucionan hora a hora, equipos clínicos multi-agente y decisiones con consecuencia narrativa — <italic>no un puntaje restado</italic>.",
  "login.feature.reasoning.title": "Razonamiento expuesto",
  "login.feature.reasoning.body":
    "Trazas del reasoner comparadas con tu lógica en cada decisión crítica.",
  "login.feature.longitudinal.title": "Pacientes longitudinales",
  "login.feature.longitudinal.body":
    "Evolucionan horas, días, semanas. Los errores no se borran — quedan en la historia clínica.",
  "login.feature.culture.title": "Cultura latinoamericana",
  "login.feature.culture.body":
    "Epidemiología, registros lingüísticos y sistema sanitario argentino por defecto. Extensible.",
  "login.form.eyebrow": "§ 02 · Acceso institucional",
  "login.form.heading.prefix": "Iniciá",
  "login.form.heading.suffix": "turno",
  "login.form.subtitle":
    "Presentate al hospital virtual con tu correo institucional. Tu actividad queda en la historia clínica de tu rotación.",
  "login.form.email": "Correo institucional",
  "login.form.email.placeholder": "alumno@universidad.com.ar",
  "login.form.password": "Contraseña",
  "login.form.forgot": "¿Olvidaste?",
  "login.form.forgot.toast": "Contactá a tu coordinador académico",
  "login.form.submit": "Iniciar turno",
  "login.form.submitting": "Iniciando turno…",
  "login.form.totp": "Código 2FA (6 dígitos)",
  "login.form.totp.invalid":
    "Código 2FA inválido. Revisá tu app autenticadora.",
  "login.error.network":
    "No pudimos conectarnos al servidor. Revisá tu conexión.",
  "login.error.400": "Formato de correo o contraseña inválido.",
  "login.error.401": "Correo o contraseña incorrectos.",
  "login.error.403":
    "Tu cuenta está desactivada. Contactá al coordinador académico.",
  "login.error.429":
    "Demasiados intentos. Intentá de nuevo en unos minutos.",
  "login.error.5xx":
    "El servidor está temporalmente fuera de servicio. Intentá en unos minutos.",
  "login.error.default": "Algo salió mal al iniciar sesión.",
  "login.privacy.label": "Privacidad",
  "login.privacy.value": "Cifrado TLS · Ley 25.326 / Argentina",

  "nav.group.clinical": "Práctica clínica",
  "nav.group.learning": "Aprendizaje longitudinal",
  "nav.group.teacher": "Panel docente",
  "nav.group.account": "Cuenta",
  "nav.library": "Biblioteca",
  "nav.active": "Mis pacientes",
  "nav.cognitive": "Mapa cognitivo",
  "nav.srs": "Flashcards",
  "nav.mcq": "Preguntas MCQ",
  "nav.evidence": "Evidencia",
  "nav.anatomy": "Anatomía 3D",
  "nav.viva": "Viva voce",
  "nav.achievements": "Logros y ranking",
  "nav.teacher.dashboard": "Tablero docente",
  "nav.teacher.caseBuilder": "Creador de casos",
  "nav.security": "Seguridad y 2FA",
  "nav.logout": "Cerrar sesión",

  "login.brand.tagline": "Hospital virtual",
  "login.brand.partnerLabel": "En colaboración con",
  "login.brand.partnerValue": "Universidad de La Frontera",
  "login.location": "En línea · Buenos Aires (UTC−3)",
  "login.status.live": "Hospital virtual en vivo",
  "login.ticker.live": "En vivo",
  "login.ticker.active": "Pacientes activos",
  "login.ticker.reasoners": "Reasoners corriendo",
  "login.ticker.casesToday": "Casos hoy",
  "login.ticker.traces": "Trazas de razonamiento",
  "login.ticker.latency": "Latencia p50",
  "login.ticker.uptime": "Uptime",
  "login.account.testLabel": "Dev seed",
  "login.tagline.italic": "no un puntaje restado",

  "common.loading": "Cargando…",
  "common.cancel": "Cancelar",
  "common.retry": "Reintentar",
  "common.skipToMain": "Saltar al contenido principal",
  "common.welcome": "Bienvenido",
};
